import { createContext } from 'react';

import { ClientBalanceContext as ClientBalanceContextProps } from './interfaces';

export const ClientBalanceContext = createContext<ClientBalanceContextProps>({} as ClientBalanceContextProps);
